// Disable noisy console methods globally, with an opt-in to re-enable via flags
// Leaves warnings and errors intact by default
(function setupConsoleSilencer() {
  if (typeof window === 'undefined' || !window.console) return;

  const isTruthy = (value) => {
    if (typeof value !== 'string') return false;
    const v = value.toLowerCase();
    return v === '1' || v === 'true' || v === 'on' || v === 'yes';
  };

  let debugEnabled = false; // Set to false to silence console.log/info/debug in production
  // Always keep logs visible for local development
  try {
    const host = String(window.location.hostname || '').toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1') {
      debugEnabled = true;
    }
  } catch (_e) {}
  try {
    const params = new URLSearchParams(window.location.search || '');
    if (isTruthy(params.get('debug')) || isTruthy(params.get('logs'))) debugEnabled = true;
  } catch (_e) {}
  try {
    const ls = window.localStorage;
    if (ls) {
      const key = ls.getItem('DEBUG_LOGS') || ls.getItem('ENABLE_DEBUG_LOGS');
      if (isTruthy(key)) debugEnabled = true;
    }
  } catch (_e) {}
  try {
    const ss = window.sessionStorage;
    if (ss) {
      const key = ss.getItem('DEBUG_LOGS') || ss.getItem('ENABLE_DEBUG_LOGS');
      if (isTruthy(key)) debugEnabled = true;
    }
  } catch (_e) {}
  try {
    if (window.__ENABLE_DEBUG_LOGS === true) debugEnabled = true;
  } catch (_e) {}

  if (debugEnabled) return;

  const noop = () => {};

  // Preserve a reference to the original console for debugging if needed
  try {
    window.__originalConsole = { ...window.console };
  } catch (_e) {}

  // Silence verbose methods globally
  try { console.log = noop; } catch (_e) {}
  try { console.info = noop; } catch (_e) {}
  try { console.debug = noop; } catch (_e) {}
  // Optionally silence warnings/errors too by uncommenting below
  // try { console.warn = noop; } catch (_e) {}
  // try { console.error = noop; } catch (_e) {}
})();

